var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex container h-screen w-full",attrs:{"id":"app"}},[_c('sidebar'),_c('tweet'),_c('trending')],1)}
var staticRenderFns = []

export { render, staticRenderFns }